import React from 'react';

import styles from './OfflineMode.module.scss';
import { NOT_AUTHORIZED } from './copy';

export type NotAuthorizedProps = {
  isGrandfathered?: boolean;
};

export default function NotAuthorized({ isGrandfathered = false }: NotAuthorizedProps) {
  return (
    <section className={styles.page} data-test-id="offlineModeNotAuthorized">
      <h3 className={styles.statusHeading}>{NOT_AUTHORIZED.title}</h3>
      <p className={styles.body}>{NOT_AUTHORIZED.body}</p>
      <p className={styles.body}>{NOT_AUTHORIZED.ask}</p>
      {isGrandfathered ? (
        <p className={styles.body} data-test-id="offlineModeGrandfatheredNote">
          Your access to this console comes from being an organization administrator. This
          organization may require the dedicated permission for Offline Mode specifically.
        </p>
      ) : null}
    </section>
  );
}
